import { ENV } from '@/constants';
import { exploreSchemaItemList } from '../exploreSchema';

export const schemaObject_WebmToMp4Converter = {
	'@context': 'https://schema.org',
	'@graph': [
		{
			'@type': 'WebPage',
			'@id': 'https://liftapp.ai/webm-to-mp4-converter',
			name: 'WEBM to MP4 Converter Online — Fast by Lift',
			description:
				'Convert WEBM to MP4 online — upload your WEBM file and Lift converts it to MP4 in seconds. High quality, no software needed. Try Lift now!',
			image: 'https://liftapp.ai/seo-image.webp',
			mainEntity: [
				{ '@id': 'https://liftapp.ai/webm-to-mp4-converter#product' },
				{ '@id': 'https://liftapp.ai/webm-to-mp4-converter#howto' },
				{ '@id': 'https://liftapp.ai/webm-to-mp4-converter#faq' },
				{ '@id': 'https://liftapp.ai/webm-to-mp4-converter#why-lift' },
				{ '@id': 'https://liftapp.ai/webm-to-mp4-converter#explore-tools' },
				{ '@id': 'https://liftapp.ai/webm-to-mp4-converter#all-in-one' },
			],
		},
		{
			'@type': 'Product',
			'@id': 'https://liftapp.ai/webm-to-mp4-converter#product',
			name: 'WEBM to MP4 Converter Online',
			description:
				'Convert WEBM files to MP4 and dozens of other formats. Upload your WEBM file, choose MP4 as output, and download the result in seconds.',
			url: 'https://liftapp.ai/webm-to-mp4-converter',
			fileFormat: [
				'video/mp4',
				'video/webm',
				'video/quicktime',
				'video/x-msvideo',
				'video/x-matroska',
			],
			memoryRequirements: 'Max file size: 2GB',
			brand: { '@type': 'Brand', name: 'Lift' },
			aggregateRating: {
				'@type': 'AggregateRating',
				ratingValue: '4.8',
				reviewCount: 130000,
				bestRating: '5',
				worstRating: '1',
			},
			interactionStatistic: [
				{
					'@type': 'InteractionCounter',
					interactionType: { '@type': 'InstallAction' },
					userInteractionCount: 13000000,
				},
			],
		},
		{
			'@type': 'HowTo',
			'@id': 'https://liftapp.ai/webm-to-mp4-converter#howto',
			name: 'How it works',
			step: [
				{
					'@type': 'HowToStep',
					position: 1,
					name: 'Upload Your WEBM File',
					text: 'Drop in your WEBM file or any other supported video format — MP4, MOV, AVI, MKV, FLV, and more.',
				},
				{
					'@type': 'HowToStep',
					position: 2,
					name: 'Choose MP4 as Output',
					text: 'Select MP4 from dozens of video and audio output formats — MOV, MKV, AVI, WEBM, MP3, AAC, and more are also available.',
				},
				{
					'@type': 'HowToStep',
					position: 3,
					name: 'Lift Converts Your File',
					text: 'Lift processes your WEBM file with high-fidelity encoding, preserving the original video and audio quality.',
				},
				{
					'@type': 'HowToStep',
					position: 4,
					name: 'Download the MP4',
					text: 'Your MP4 file is ready instantly — download it for playback, editing, streaming, or sharing.',
				},
			],
		},
		{
			'@type': 'FAQPage',
			'@id': 'https://liftapp.ai/webm-to-mp4-converter#faq',
			mainEntity: [
				{
					'@type': 'Question',
					name: 'What is the Lift WEBM to MP4 Converter?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Lift WEBM to MP4 Converter is an online tool that converts WEBM files to MP4 and dozens of other formats in seconds. Upload your WEBM file, choose an output format, and download the result.',
					},
				},
				{
					'@type': 'Question',
					name: 'How does the Lift WEBM to MP4 Converter work?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Upload your WEBM file, select MP4 as the output format, and Lift processes the conversion. Your MP4 file is ready to download in seconds.',
					},
				},
				{
					'@type': 'Question',
					name: 'How long does WEBM to MP4 conversion take?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Most conversions complete in seconds. Processing time depends on file size, but Lift is optimized to deliver results as fast as possible.',
					},
				},
				{
					'@type': 'Question',
					name: 'Will converting WEBM to MP4 affect quality?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Lift uses high-fidelity encoding that preserves the original video resolution and audio quality through every conversion.',
					},
				},
				{
					'@type': 'Question',
					name: 'Is it safe to convert files with Lift?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Yes. Lift prioritizes your privacy — all files are processed securely and are not stored or shared after conversion. Your converted result is available only to you.',
					},
				},
			],
		},
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/webm-to-mp4-converter#why-lift',
			name: "Why Lift's WEBM to MP4 Converter stands out",
			description:
				'High-quality results, intelligent encoding, cross-platform support, and budget-friendly pricing — Lift delivers professional-grade video conversion.',
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'No Quality Loss',
					description:
						"Lift preserves your video's original resolution and audio quality through every conversion.",
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Intelligent encoding',
					description:
						'AI tailors the conversion to the source file for optimal MP4 output.',
				},
				{
					'@type': 'ListItem',
					position: 3,
					name: 'Cross-platform support',
					description:
						'Available on iOS, Android, and Web for seamless access.',
				},
				{
					'@type': 'ListItem',
					position: 4,
					name: 'Budget-friendly',
					description:
						'Save on costly software with an affordable and intuitive tool.',
				},
			],
			image: {
				'@type': 'ImageObject',
				contentUrl:
					'https://liftapp.ai/images/webm-to-mp4-converter/whyLift.webp',
				name: 'Lift WEBM to MP4 Converter delivering high-quality output',
				description: "Lift's online WEBM to MP4 converter in high resolution.",
			},
		},
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/webm-to-mp4-converter#explore-tools',
			name: 'Explore the AI tools',
			description:
				'A curated list of AI-powered tools for image generation, enhancement, background removal, and more – all available on Lift.',
			itemListOrder: 'Unordered',
			...exploreSchemaItemList,
		},
		{
			'@type': 'SoftwareApplication',
			'@id': 'https://liftapp.ai/webm-to-mp4-converter#all-in-one',
			name: 'Try Lift – AI Content Creation Tools',
			description:
				'Your all-in-one tools to create, edit, and elevate your content. Create stunning content with AI tools, templates, and editing features effortlessly.',
			operatingSystem: 'iOS, Android, Web',
			applicationCategory: 'MultimediaApplication',
			url: `${ENV.LIFT_WEB_APP_URL}/sign-in?auto_login=true`,
			applicationSubCategory: 'Content Creation',
			publisher: {
				'@type': 'Organization',
				name: 'Lift',
				url: 'https://liftapp.ai',
			},
			potentialAction: [
				{
					'@type': 'ViewAction',
					name: 'Open Web App',
					target: `${ENV.LIFT_WEB_APP_URL}/sign-in?auto_login=true`,
				},
			],
		},
		{
			'@type': 'BreadcrumbList',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'Home',
					item: 'https://liftapp.ai',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'WEBM to MP4 Converter',
					item: 'https://liftapp.ai/webm-to-mp4-converter',
				},
			],
		},
	],
};
